<template>
  <section>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-2"></div>
         <div class="col-lg-4">
            <s-time-picker :data="backup_time" :start_time="true" :placeholder="'00:00'" :options="config_hour.start" :name="'start_time'" :id="'start_time'" :validation="'required'" :label="'backup_schedule'" @input="startTime(backup_time.start_time)"></s-time-picker>
            <span v-show="errors.has('backup_time')" class="m-form__help m--font-danger"> {{errors.first('backup_time')}} </span>
        </div>
        <div class="col-lg-4">
          <label for="route">{{'route' | translate | capitalize }}</label>
          <select v-model="route" id="route" name="route" class="form-control m-bootstrap-select m_selectpicker" v-validate="'required'">
            <option  value="root">{{ 'route_backup_default' | translate | capitalize }}</option>
            <option v-for="device in devices" :key="device.dev" :value="device.dev">{{ device.label }}</option>
          </select>            
          <span v-show="errors.has('route')" class="m-form__help m--font-danger"> {{errors.first('route')}} </span>
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col-md-1"></div>
          <div class="col-md-5">
            <a @click.prevent="backupTime" href="#" class="btn btn-primary btn-block m-btn m-btn--icon">
              <span>
                <i class="flaticon-tool"></i>
                <span>{{ 'save' | translate | capitalize }}</span>
              </span>
            </a>
          </div>
          <div class="col-md-5">
            <a @click.prevent="backupAction" href="#" class="btn btn-primary btn-block m-btn m-btn--icon">
              <span>
                <i class="flaticon-tool"></i>
                <span>{{ 'backup_now' | translate | capitalize }}</span>
              </span>
            </a>
          </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="resetForm" id="btn-cancel">
        {{ 'close' | translate | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import STimePicker from '@/components/layout/timepicker/TimePicker.vue'
export default {
  components: { STimePicker },
  data () {
    return {
      backup_time: {
        start_time: '',
        end_time: ''
      },
      config_hour: {
        start: {
          minuteStep: 1,
          showMeridian: false,
          explicitMode: true,
          showWidget: true,
          showInputs: false,
          defaultTime: '06:00'
        },
        end: {
          minuteStep: 1,
          showMeridian: false,
          explicitMode: true,
          showWidget: true,
          showInputs: false,
          defaultTime: '18:00'
        }
      },
      devices: [],
      route: 'root'
    }
  },
  methods: {
    ...mapActions(['backup', 'setTimeBackup', 'getTimeBackup', 'setStatusBackupModal', 'retrieveDevices']),
    resetForm () {
      window.$('#backup_modal').modal('hide')
      this.setStatusBackupModal(false)
    },
    backupAction () {
      this.$spinner.show()
      this.backup()
        .then(() => {
          this.$spinner.remove()
          this.resetForm()
          this.$toast('backup_successful', 1)
        })
        .catch(() => {
          this.$spinner.remove()
          this.resetForm()
          this.$toast('backup_error', 4)
        })
    },
    backupTime () {
      this.$spinner.show()
      this.setTimeBackup({time: this.backup_time.start_time, route: this.route})
        .then(() => {
          this.$spinner.remove()
          this.resetForm()
          this.$toast('backup_time_successful', 1)
        })
        .catch(() => {
          this.$spinner.remove()
          this.resetForm()
          this.$toast('backup_time_error', 4)
        })
    },
    startTime (value) {
      let start = parseInt(this.backup_time.start_time.replace(':', ''))
      let end = this.backup_time.end_time ? parseInt(this.backup_time.end_time.replace(':', '')) : ''
      if (start > (end || isNaN(end) === false)) {
        this.backup_time.end_time = this.backup_time.start_time
      }
    }
  },
  created () {
    this.retrieveDevices()
      .then((res) => {
        this.devices = res.data
      })
      .catch((err) => {
        console.log(err)
      })
    this.getTimeBackup()
      .then((res) => {
        this.backup_time.start_time = res.data.hour_backup
        this.route = res.data.route_backup
      })
      .catch((e) => {
        console.log(e)
      })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Backup.vue